import React from 'react';
import {observer} from 'mobx-react';
import Modal from '../Modal';
import Store from '../stores/store';
import {I18n, MessageProvider, TProvider} from '../i18n/i18n';
import CurrencySetting from './Setting/CurrencySetting';
import {stylesheet} from 'typestyle';
import {BlackColorFaded05} from '../styles/colors';

interface CurrencySettingProps {
    store: Store;
}

export interface CurrencyAndChannel {
    name: string;
    currency: string;
}

interface CurrencySettingModalState {
    currenciesPerChannel: CurrencyAndChannel[];
}

interface SettingsListItem {
    title: string;
    settingComponent: React.ReactNode;
}

@observer
export class SettingModal extends React.Component<CurrencySettingProps, CurrencySettingModalState> {
    private closeModal = () => {
        this.props.store.settingModalOpen = false;
    };

    private getSettingsList(t: MessageProvider): SettingsListItem[] {
        return [
            {
                title: t('currency.currencySettings'),
                settingComponent: <CurrencySetting store={this.props.store} />,
            },
        ];
    }

    public render() {
        return (
            <Modal
                onModalClose={this.closeModal}
                modalHeader={
                    <div>
                        <I18n i18nKey="setting" />
                    </div>
                }
                modalBody={
                    <TProvider>
                        {(t) =>
                            this.getSettingsList(t).map((settingsItem) => (
                                <div key={settingsItem.title} className={settingCss.settingContainer}>
                                    <div>{settingsItem.title}</div>
                                    <div>{settingsItem.settingComponent}</div>
                                </div>
                            ))
                        }
                    </TProvider>
                }
                store={this.props.store}
            />
        );
    }
}

const settingCss = stylesheet({
    settingContainer: {
        backgroundColor: BlackColorFaded05,
        overflow: 'auto',
        padding: 15,
        borderRadius: 2,
    },
});



// WEBPACK FOOTER //
// ./src/views/SettingModal.tsx